import { ReactElement } from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import Terms from './pages/Terms'

export default function Router (): ReactElement {
  return <Routes>
    <Route element={<Home />} path="/" />
    <Route element={<Terms />} path="/termos-de-adesao" />
  </Routes>
}
